'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SystemOverridesTabs } from '@/features/device-assignment-rule/components';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { DeviceAssignmentRuleShell } from '../-components/DeviceAssignmentRuleShell';
import { RuleFormPage } from '../-components/RuleFormPage';
export const Route = createFileRoute('/_staff/devices/_list/rule-and-policy/system-exceptions/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.ruleAndPolicy'
  });
  const navigate = useNavigate();
  useDocumentTitle(t('inclusions.systemTitle'));
  return <DeviceAssignmentRuleShell>
      <RuleFormPage title={t('inclusions.systemTitle')} onBack={() => navigate({
      to: '/devices/rule-and-policy'
    })} mode="view">
        <SystemOverridesTabs />
      </RuleFormPage>
    </DeviceAssignmentRuleShell>;
}